import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const StyledSVG = styled.svg`
  display: block;
  margin: auto;
  .fill.fill.fill {transition: fill 2s linear; fill: rgb(255, 255, 255)}
  .grad.grad.grad {${({ theme }) => theme.palette.background.primaryGrad}}
  .st0 {transition: fill 2s linear;}
  height: 25rem;
  width: 25rem;


  .st0{fill:none;stroke:rgba(255, 255, 255, 0.7);stroke-width:4;stroke-miterlimit:10;}
  .st1{fill:none;stroke:rgba(255, 255, 255, 0.7);stroke-miterlimit:10;}
  
  .dmvkjXSq_0{stroke-dasharray:1145 1147;stroke-dashoffset:1146;animation:dmvkjXSq_draw 3275ms linear 0ms forwards;}.dmvkjXSq_1{stroke-dasharray:376 378;stroke-dashoffset:377;animation:dmvkjXSq_draw 1077ms linear 3275ms forwards;}.dmvkjXSq_2{stroke-dasharray:38 40;stroke-dashoffset:39;animation:dmvkjXSq_draw 111ms linear 4353ms forwards;}.dmvkjXSq_3{stroke-dasharray:38 40;stroke-dashoffset:39;animation:dmvkjXSq_draw 111ms linear 4464ms forwards;}.dmvkjXSq_4{stroke-dasharray:38 40;stroke-dashoffset:39;animation:dmvkjXSq_draw 111ms linear 4576ms forwards;}.dmvkjXSq_5{stroke-dasharray:38 40;stroke-dashoffset:39;animation:dmvkjXSq_draw 111ms linear 4687ms forwards;}.dmvkjXSq_6{stroke-dasharray:38 40;stroke-dashoffset:39;animation:dmvkjXSq_draw 111ms linear 4799ms forwards;}.dmvkjXSq_7{stroke-dasharray:38 40;stroke-dashoffset:39;animation:dmvkjXSq_draw 111ms linear 4910ms forwards;}.dmvkjXSq_8{stroke-dasharray:19 21;stroke-dashoffset:20;animation:dmvkjXSq_draw 57ms linear 5022ms forwards;}.dmvkjXSq_9{stroke-dasharray:19 21;stroke-dashoffset:20;animation:dmvkjXSq_draw 57ms linear 5079ms forwards;}.dmvkjXSq_10{stroke-dasharray:19 21;stroke-dashoffset:20;animation:dmvkjXSq_draw 57ms linear 5136ms forwards;}.dmvkjXSq_11{stroke-dasharray:19 21;stroke-dashoffset:20;animation:dmvkjXSq_draw 57ms linear 5193ms forwards;}.dmvkjXSq_12{stroke-dasharray:19 21;stroke-dashoffset:20;animation:dmvkjXSq_draw 57ms linear 5250ms forwards;}.dmvkjXSq_13{stroke-dasharray:19 21;stroke-dashoffset:20;animation:dmvkjXSq_draw 57ms linear 5308ms forwards;}.dmvkjXSq_14{stroke-dasharray:13 15;stroke-dashoffset:14;animation:dmvkjXSq_draw 40ms linear 5365ms forwards;}.dmvkjXSq_15{stroke-dasharray:13 15;stroke-dashoffset:14;animation:dmvkjXSq_draw 40ms linear 5405ms forwards;}.dmvkjXSq_16{stroke-dasharray:13 15;stroke-dashoffset:14;animation:dmvkjXSq_draw 40ms linear 5445ms forwards;}.dmvkjXSq_17{stroke-dasharray:13 15;stroke-dashoffset:14;animation:dmvkjXSq_draw 40ms linear 5485ms forwards;}.dmvkjXSq_18{stroke-dasharray:12 14;stroke-dashoffset:13;animation:dmvkjXSq_draw 37ms linear 5525ms forwards;}.dmvkjXSq_19{stroke-dasharray:13 15;stroke-dashoffset:14;animation:dmvkjXSq_draw 40ms linear 5562ms forwards;}.dmvkjXSq_20{stroke-dasharray:23 25;stroke-dashoffset:24;animation:dmvkjXSq_draw 68ms linear 5602ms forwards;}.dmvkjXSq_21{stroke-dasharray:23 25;stroke-dashoffset:24;animation:dmvkjXSq_draw 68ms linear 5671ms forwards;}.dmvkjXSq_22{stroke-dasharray:22 24;stroke-dashoffset:23;animation:dmvkjXSq_draw 65ms linear 5739ms forwards;}.dmvkjXSq_23{stroke-dasharray:23 25;stroke-dashoffset:24;animation:dmvkjXSq_draw 68ms linear 5805ms forwards;}.dmvkjXSq_24{stroke-dasharray:23 25;stroke-dashoffset:24;animation:dmvkjXSq_draw 68ms linear 5874ms forwards;}.dmvkjXSq_25{stroke-dasharray:22 24;stroke-dashoffset:23;animation:dmvkjXSq_draw 65ms linear 5942ms forwards;}.dmvkjXSq_26{stroke-dasharray:16 18;stroke-dashoffset:17;animation:dmvkjXSq_draw 48ms linear 6008ms forwards;}.dmvkjXSq_27{stroke-dasharray:16 18;stroke-dashoffset:17;animation:dmvkjXSq_draw 48ms linear 6057ms forwards;}.dmvkjXSq_28{stroke-dasharray:16 18;stroke-dashoffset:17;animation:dmvkjXSq_draw 48ms linear 6105ms forwards;}.dmvkjXSq_29{stroke-dasharray:16 18;stroke-dashoffset:17;animation:dmvkjXSq_draw 48ms linear 6154ms forwards;}.dmvkjXSq_30{stroke-dasharray:16 18;stroke-dashoffset:17;animation:dmvkjXSq_draw 48ms linear 6202ms forwards;}.dmvkjXSq_31{stroke-dasharray:16 18;stroke-dashoffset:17;animation:dmvkjXSq_draw 48ms linear 6251ms forwards;}@keyframes dmvkjXSq_draw{100%{stroke-dashoffset:0;}}@keyframes dmvkjXSq_fade{0%{stroke-opacity:1;}96.19047619047619%{stroke-opacity:1;}100%{stroke-opacity:0;}}
`

const Animatedq = () => {
  const [ toggle, setToggle ] = useState(false)
  const toggleClass = () => {
    setToggle(!toggle)
  }
  useEffect(() => {
    const timer = setTimeout(() => {
      toggleClass()
    }, 6500)
    return () => clearTimeout(timer)
  }, [])

  return (
    <StyledSVG
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 327.1 463'
      preserveAspectRatio='xMidYMin'
    >
      <path
        className='st0 dmvkjXSq_0' d='M296.7,88.3c-8.8-16.1-20.1-29.7-33.9-40.8c-13.9-11.1-29.5-20-46.7-26.6c-17.3-6.6-34.5-9.9-51.6-9.9
        C99.5,11,50,39.3,15.8,96.1c-1.7,2.8-2.3,5.8-1.8,9c0.5,3.2,2.2,5.9,5,8l52.5,40c2.8,1.7,5.4,2.6,8,2.6c3.8,0,7.1-1.7,9.9-5.1
        c15.4-19.2,26.8-31.5,34.3-36.8c9.2-6.2,20.7-9.3,34.6-9.3c13,0,24.5,3.4,34.4,10.2c9.9,6.8,14.9,14.7,14.9,23.7
        c0,10-2.7,18.1-8,24.3c-5.3,6.2-14.3,12.2-26.9,17.9c-16.6,7.5-31.9,19.1-45.8,34.7c-13.9,15.7-20.8,32.4-20.8,50.1v14.4
        c0,4.1,1.1,8.1,3.4,12c2.2,4,5,5.9,8.2,5.9h76.8c3.4,0,6.4-1.7,9-5c2.6-3.3,3.8-6.8,3.8-10.4c0-5.3,2.9-12.5,8.8-21.5
        c5.9-9,13.2-15.9,21.9-20.8c8.3-4.7,14.8-8.5,19.5-11.4c4.7-2.9,10.8-7.5,18.4-13.9c7.6-6.4,13.4-12.8,17.6-19.1
        c4.2-6.3,7.9-14.5,11.2-24.5c3.3-10,5-20.8,5-32.3C309.8,121.3,305.4,104.4,296.7,88.3z'
      />
      <circle className='st0 dmvkjXSq_1' cx='157.6' cy='386.2' r='59.7' />
      <g>
        <path
          className={`st1 dmvkjXSq_2 ${toggle ? `fill` : ''}`} d='M150.2,377.9c-2.3,0-4.3-1.3-5.3-3.3c-1.5-2.9-0.3-6.5,2.6-8c0.8-0.4,1.8-0.6,2.7-0.6c2.3,0,4.3,1.3,5.3,3.3
        c1.5,2.9,0.3,6.5-2.6,8C152,377.7,151.1,377.9,150.2,377.9'
        />
        <path
          className={`st1 dmvkjXSq_3 ${toggle ? `fill` : ''}`} d='M143.2,390.1c-0.1,0-0.2,0-0.3,0c-3.3-0.2-5.8-3-5.6-6.3s3-5.8,6.3-5.6c3.3,0.2,5.8,3,5.6,6.3
        C148.9,387.6,146.3,390.1,143.2,390.1'
        />
        <path
          className={`st1 dmvkjXSq_4 ${toggle ? `fill` : ''}`} d='M150.2,402.3c-1.2,0-2.3-0.3-3.3-1c-1.3-0.9-2.2-2.2-2.6-3.8c-0.3-1.6,0-3.2,0.9-4.5c1.1-1.7,3-2.7,5-2.7
        c1.2,0,2.3,0.3,3.3,1c1.3,0.9,2.3,2.2,2.6,3.8c0.3,1.6,0,3.2-0.9,4.5C154.1,401.3,152.2,402.3,150.2,402.3'
        />
        <path
          className={`st1 dmvkjXSq_5 ${toggle ? `fill` : ''}`} d='M164.3,402.2c-2.3,0-4.3-1.3-5.3-3.3c-0.7-1.4-0.8-3-0.3-4.6c0.5-1.5,1.6-2.7,3-3.5c0.8-0.4,1.8-0.6,2.7-0.6
        c2.3,0,4.3,1.3,5.3,3.3c1.5,2.9,0.3,6.5-2.6,8C166.2,402,165.2,402.2,164.3,402.2'
        />
        <path
          className={`st1 dmvkjXSq_6 ${toggle ? `fill` : ''}`} d='M171.3,390c-0.1,0-0.2,0-0.3,0c-3.3-0.2-5.8-3-5.6-6.3s3-5.8,6.3-5.6c1.6,0.1,3.1,0.8,4.1,2
        c1.1,1.2,1.6,2.7,1.5,4.3C177.1,387.5,174.5,390,171.3,390'
        />
        <path
          className={`st1 dmvkjXSq_7 ${toggle ? `fill` : ''}`} d='M164.2,377.8c-1.2,0-2.3-0.3-3.3-1c-2.8-1.8-3.5-5.5-1.7-8.3c1.1-1.7,3-2.7,5-2.7c1.2,0,2.3,0.3,3.3,1
        c2.8,1.8,3.5,5.5,1.7,8.3C168.1,376.8,166.3,377.8,164.2,377.8'
        />
        <path
          className={`st1 dmvkjXSq_8 ${toggle ? `fill` : ''}`} d='M144.2,355.7c0.7,1.5,0.1,3.3-1.3,4c-1.5,0.7-3.3,0.1-4-1.3c-0.7-1.5-0.2-3.3,1.3-4
        C141.6,353.6,143.4,354.2,144.2,355.7'
        />
        <path
          className={`st1 dmvkjXSq_9 ${toggle ? `fill` : ''}`} d='M126.1,381.2c1.6,0.1,2.9,1.5,2.8,3.2c-0.1,1.6-1.5,2.9-3.2,2.8c-1.6-0.1-2.9-1.5-2.8-3.2
        C123,382.3,124.5,381.1,126.1,381.2'
        />
        <path
          className={`st1 dmvkjXSq_10 ${toggle ? `fill` : ''}`} d='M139.1,409.6c0.9-1.4,2.8-1.8,4.1-0.9c1.4,0.9,1.8,2.8,0.9,4.1c-0.9,1.4-2.8,1.8-4.1,0.9
        C138.6,412.8,138.2,411,139.1,409.6'
        />
        <path className={`st1 dmvkjXSq_11 ${toggle ? `fill` : ''}`} d='M170.3,412.5c-0.7-1.5-0.2-3.3,1.3-4s3.3-0.2,4,1.3s0.1,3.3-1.3,4C172.8,414.6,171,414,170.3,412.5' />
        <path
          className={`st1 dmvkjXSq_12 ${toggle ? `fill` : ''}`} d='M188.4,387c-1.7-0.1-2.9-1.5-2.8-3.1c0.1-1.7,1.5-2.9,3.1-2.8s2.9,1.5,2.8,3.2
        C191.4,385.8,190,387.1,188.4,387'
        />
        <path
          className={`st1 dmvkjXSq_13 ${toggle ? `fill` : ''}`} d='M175.3,358.6c-0.9,1.4-2.8,1.8-4.1,0.9c-1.4-0.9-1.8-2.8-0.9-4.1c0.9-1.4,2.8-1.8,4.1-0.9
        C175.8,355.3,176.2,357.2,175.3,358.6'
        />
        <path className={`st1 dmvkjXSq_14 ${toggle ? `fill` : ''}`} d='M137.7,346.5c0.5,1,0.1,2.1-0.9,2.6s-2.1,0.1-2.6-0.9s-0.1-2.1,0.9-2.6C136,345.2,137.2,345.6,137.7,346.5' />
        <path
          className={`st1 dmvkjXSq_15 ${toggle ? `fill` : ''}`} d='M114.9,382.2c1.1,0.1,1.9,1,1.8,2c-0.1,1.1-1,1.9-2,1.8c-1.1-0.1-1.9-1-1.8-2
        C112.9,383,113.8,382.2,114.9,382.2'
        />
        <path
          className={`st1 dmvkjXSq_16 ${toggle ? `fill` : ''}`} d='M134.5,419.8c0.6-0.9,1.8-1.1,2.7-0.6c0.9,0.6,1.1,1.8,0.5,2.7c-0.6,0.9-1.8,1.1-2.7,0.6
        C134.1,421.9,133.9,420.7,134.5,419.8'
        />
        <path className={`st1 dmvkjXSq_17 ${toggle ? `fill` : ''}`} d='M176.8,421.6c-0.5-1-0.1-2.1,0.9-2.6s2.1-0.1,2.6,0.9s0.1,2.1-0.9,2.6C178.4,423,177.3,422.6,176.8,421.6' />
        <path
          className={`st1 dmvkjXSq_18 ${toggle ? `fill` : ''}`} d='M199.5,385.9c-1.1-0.1-1.9-1-1.8-2c0.1-1.1,1-1.9,2-1.8c1.1,0.1,1.9,1,1.8,2
        C201.5,385.2,200.6,386,199.5,385.9'
        />
        <path
          className={`st1 dmvkjXSq_19 ${toggle ? `fill` : ''}`} d='M180,348.3c-0.6,0.9-1.8,1.1-2.7,0.6c-0.9-0.6-1.1-1.8-0.6-2.7c0.6-0.9,1.8-1.1,2.7-0.6
        C180.3,346.3,180.6,347.5,180,348.3'
        />
        <path
          className={`st1 dmvkjXSq_20 ${toggle ? `fill` : ''}`} d='M138.2,369.1c1.6,1.1,2.1,3.2,1,4.9c-1.1,1.6-3.2,2.1-4.9,1c-1.6-1.1-2.1-3.2-1-4.9
        C134.4,368.5,136.6,368.1,138.2,369.1'
        />
        <path
          className={`st1 dmvkjXSq_21 ${toggle ? `fill` : ''}`} d='M134.8,393c1.7-0.9,3.8-0.2,4.7,1.6c0.9,1.7,0.2,3.8-1.6,4.7c-1.7,0.9-3.8,0.2-4.7-1.6
        C132.4,396,133.1,393.9,134.8,393'
        />
        <path
          className={`st1 dmvkjXSq_22 ${toggle ? `fill` : ''}`} d='M153.5,408c0.1-1.9,1.8-3.4,3.7-3.3s3.4,1.8,3.3,3.7c-0.1,1.9-1.8,3.4-3.7,3.3
        C154.9,411.6,153.4,409.9,153.5,408'
        />
        <path
          className={`st1 dmvkjXSq_23 ${toggle ? `fill` : ''}`} d='M176.2,399c-1.6-1.1-2.1-3.2-1-4.9c1.1-1.6,3.2-2.1,4.9-1c1.6,1.1,2.1,3.2,1,4.9
        C180,399.6,177.8,400.1,176.2,399'
        />
        <path
          className={`st1 dmvkjXSq_24 ${toggle ? `fill` : ''}`} d='M179.7,375.1c-1.7,0.9-3.8,0.2-4.7-1.6c-0.9-1.7-0.2-3.8,1.6-4.7c1.7-0.9,3.8-0.2,4.7,1.6
        C182.1,372.1,181.4,374.2,179.7,375.1'
        />
        <path
          className={`st1 dmvkjXSq_25 ${toggle ? `fill` : ''}`} d='M160.7,360.2c-0.1,1.9-1.8,3.4-3.7,3.3s-3.4-1.8-3.3-3.7c0.1-1.9,1.8-3.4,3.7-3.3
        C159.3,356.6,160.8,358.2,160.7,360.2'
        />
        <path
          className={`st1 dmvkjXSq_26 ${toggle ? `fill` : ''}`} d='M125.2,362.8c1.1,0.7,1.5,2.3,0.7,3.4c-0.7,1.1-2.3,1.5-3.4,0.7c-1.1-0.7-1.5-2.3-0.7-3.4
        C122.5,362.4,124,362.1,125.2,362.8'
        />
        <path
          className={`st1 dmvkjXSq_27 ${toggle ? `fill` : ''}`} d='M122.8,401.2c1.2-0.6,2.7-0.1,3.3,1.1c0.6,1.2,0.1,2.7-1.1,3.3c-1.2,0.6-2.7,0.1-3.3-1.1
        S121.6,401.8,122.8,401.2'
        />
        <path
          className={`st1 dmvkjXSq_28 ${toggle ? `fill` : ''}`} d='M154.6,422.5c0.1-1.4,1.2-2.4,2.6-2.3c1.4,0.1,2.4,1.2,2.3,2.6c-0.1,1.4-1.2,2.4-2.6,2.3
        C155.6,425,154.5,423.8,154.6,422.5'
        />
        <path
          className={`st1 dmvkjXSq_29 ${toggle ? `fill` : ''}`} d='M189.3,405.3c-1.1-0.7-1.5-2.3-0.7-3.4c0.7-1.1,2.3-1.5,3.4-0.7c1.1,0.7,1.4,2.3,0.7,3.4
        C192,405.7,190.4,406.1,189.3,405.3'
        />
        <path
          className={`st1 dmvkjXSq_30 ${toggle ? `fill` : ''}`} d='M191.7,366.9c-1.2,0.6-2.7,0.1-3.3-1.1s-0.1-2.7,1.1-3.3c1.2-0.6,2.7-0.1,3.3,1.1
        C193.4,364.8,192.9,366.3,191.7,366.9'
        />
        <path
          className={`st1 dmvkjXSq_31 ${toggle ? `fill` : ''}`} d='M159.6,345.7c-0.1,1.4-1.2,2.4-2.6,2.3c-1.4-0.1-2.4-1.2-2.3-2.6c0.1-1.4,1.2-2.4,2.6-2.3
        C158.6,343.2,159.7,344.3,159.6,345.7'
        />
      </g>
    </StyledSVG>
  )
}

export default Animatedq
